/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const WIDGETS_PATH =
  'M7.9625 6.59167L4.66667 3.29583L7.9625 0L11.2583 3.29583L7.9625 6.59167ZM0 5.425V0.758333H4.66667V5.425H0ZM5.83333 11.2583V6.59167H10.5V11.2583H5.83333ZM0 11.2583V6.59167H4.66667V11.2583H0ZM1.16667 4.25833H3.5V1.925H1.16667V4.25833ZM7.97708 4.95833L9.625 3.31042L7.97708 1.6625L6.32917 3.31042L7.97708 4.95833ZM7 10.0917H9.33333V7.75833H7V10.0917ZM1.16667 10.0917H3.5V7.75833H1.16667V10.0917Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Widgets / tile grid (12×12). Color via `currentColor`. */
const WidgetsIcon = ({
  size = 12,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={WIDGETS_PATH} fill="currentColor" />
  </svg>
);

WidgetsIcon.propTypes = iconPropTypes;

export { WidgetsIcon };
export default WidgetsIcon;
